module.exports = __webpack_public_path__ + "static/generic-event-picture-a6db77f16e30d83793bed738ec27cda3.png";